<div class="PGImportResource">
    @if (isLoading || isSelectingData) {
        <app-pg-loading [isOverlay]="isSelectingData"></app-pg-loading>
    }
    @if (!isLoading) {
        @if(importType == 'entourance' && realmsOptions != null) {
            <div class="row">
                <div class="col-6 form-group">
                    <label>
                        <b>{{ 'pg-import-resource.realm' | locTranslate }}</b>
                    </label>
                    <app-pg-select [options]="realmsOptions" display="oneLine" [(ngModel)]="realmSelection" (ngModelChange)="onSearchChange()"></app-pg-select>
                </div>
                <div class="col-6 PGImportResource-Realm">
                    @if(getSelectedRealmData(); as realm) {
                        <app-pg-realm-card [realmData]="realm"></app-pg-realm-card>
                    }
                </div>
            </div>
        }

        @if(tableData) {
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    @if(importType == 'entourance') {
                        <button class="btn btn-primary me-3" [disabled]="!canSelectAll()" (click)="selectAll()">
                            <i class="fa-regular fa-asterisk"></i>
                            <span>{{ 'pg-import-resource.select-all' | locTranslate }}</span>
                        </button>
                    }
        
                    @if(selection.length > 0) {
                        <span>{{ 'pg-import-resource.selected-count' | locTranslate:'count':selection.length }}</span>
                    }
                </div>
                <div>
                    @if(importType == 'entourance') {
                        <div class="input-group">
                            <input type="text" class="form-control" [(ngModel)]="searchValue" (change)="onSearchChange()" placeholder="{{ 'pg-import-resource.search' | locTranslate }}"/>
                            <div class="input-group-text {{ appliedSearchValue ? 'bg-primary text-white' : '' }}">
                                <i class="fa-regular fa-search"></i>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <table class="table">
                <thead>
                    <tr>
                        <th style="width: 5em;" class="text-center">
                        </th>
                        @for (column of tableData.columns; track column) {
                            <th [style.width]="column.width" [innerHTML]="column.label"></th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for (row of tableData.rows; track row) {
                        <tr>
                            <td class="text-center">
                                <div class="d-flex align-items-center">
                                    <input type="checkbox" [ngModel]="isSelected(row.id)" (ngModelChange)="setSelected(row.id, $event)"/>
        
                                    <button class="btn btn-link py-0 px-1 ms-2" (click)="openPreview(row.id)">
                                        <i class="fa-regular fa-magnifying-glass"></i>
                                    </button>
                                </div>
                            </td>
                            @for (column of tableData.columns; track column) {
                                <td [innerHTML]="getRowFieldOrTranslation(row, column.id)"></td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
            <div class="text-center">
                @if (isLoadingData) {
                    <app-pg-loading></app-pg-loading>
                }
                <app-pg-view-more [hidden]="isLoadingData || isAtEnd" (viewMore)="loadData()"></app-pg-view-more>
            </div>
        }
    }
</div>
